import React from 'react';
import { theme } from './theme';
import {
  common,
  red,
  green,
  blue,
  cyan,
  magenta,
  yellow,
  gray,
  orange,
  salmon,
  turquoise,
  purple
} from './color-palettes';

export const ThemeContext = React.createContext({
  theme,
  colors: {
    common,
    red,
    green,
    blue,
    cyan,
    magenta,
    yellow,
    gray,
    orange,
    salmon,
    turquoise,
    purple
  }
});
